import { render } from "./TermoUso.vue?vue&type=template&id=1e730704&scoped=true"
import script from "./TermoUso.vue?vue&type=script&lang=js"
export * from "./TermoUso.vue?vue&type=script&lang=js"

import "./TermoUso.vue?vue&type=style&index=0&id=1e730704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e730704"]])

export default __exports__